import {
    GET_DEPOSIT,
    GET_DEPOSIT_SUCCESS,
    GET_DEPOSIT_FAIL,
    RESET_DEPOSIT_ALERTS_ERRORS
} from './actionTypes';

const INIT_STATE = {
    isLoading: false,
    error: null,
    deposit: null
};

const DepositDetailed = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_DEPOSIT:
            return { ...state, isLoading: true, error: null, deposit: null };

        case GET_DEPOSIT_SUCCESS:
            return { ...state, deposit: action.payload, isLoading: false };

        case GET_DEPOSIT_FAIL:
            return { ...state, error: action.payload, isLoading: false };

        case RESET_DEPOSIT_ALERTS_ERRORS:
            return { ...state, error: null, isLoading: false };
        default:
            return state;
    }
};

export default DepositDetailed;
